<template>
	<div class="declareRoad">
		<div class="declareRoadCon">
			
			<div class="head">
				<div class="left">
					<div class="title">
						申报列表
					</div>
					<div class="label">
						<div v-for="(item,index) of statusList" :key='index' class="li"
							:class="{active:selectStatus==item.status}" @click="changeStatus(item.status)">
							{{item.name}}
						</div>
					</div>
				</div>
			</div>
			
			<div v-loading="loading" class="ul">
				<div class="nodata" v-if="list.length==0">
					<no-Data></no-Data>
				</div>
				<div v-for="(item,index) of list" :key="index" class="li">
					<div class="bottom">
						<div class="logoCon">
							<el-image :src="item.user.avatar||require('@/static/avatar.png')" fit="cover" class="logo"></el-image>
							<div class="right">
								<div class="name">
									用户姓名：{{item.user.user_name||'未填写'}}
								</div>
								<div class="time">
									联系电话：{{item.user.phone}}
								</div>
							</div>
						</div>
						<div class="controls">
							<div class="button" v-if="item.status==1" style="color: #51A190;" @click="agree(item.id)">通过申请</div>
							<div class="button" v-if="item.status==1" style="color: #FF6666;"  @click="refuse(item.id)">驳回申请</div>
						</div>
					</div>
					<div v-if="item.status==3" class="red">
						拒绝理由：{{item.remarks}}
					</div>
				</div>
			</div>
			
			
			<div v-if="total>0" class="page">
				<el-pagination background :page-size="limit" layout="prev, pager, next" :total="total"
					@current-change='changePage'>
				</el-pagination>
			</div>
			
		</div>
		
		<el-dialog
		  title="驳回说明"
		  :visible.sync="dialogVisible"
		  width="30%">
		  <el-input type="textarea" v-model="msg" style="width: 500px;"></el-input>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="controlsRequest(2)">确 定</el-button>
		  </span>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		name:'declareRoad',
		data() {
			return {
				selectStatus:1,
				statusList:[
					{
						name:'待审核',
						status:1
					},
					{
						name:'已通过',
						status:2
					},
					{
						name:'驳回',
						status:3
					},
				],
				page: 1,
				total: 0,
				loading: false,
				list: [],
				limit: 15,
				id:'',
				controlsId:'',
				dialogVisible:false,
				msg:'',
			}
		},
		created() {
			this.id=this.$route.query.id
			this.getList()
		},
		methods: {
			agree(id){
				this.$confirm('此操作将通过该用户的政策申报, 是否继续?', '通过申请', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				    this.$axios.post('/api/client/ES/policysApprove',{ id:id, type:1,}).then(res=>{
				    	if(res.code==200){
				    		this.$eltips(res.msg,'success')
				    		this.getList()
				    	}else{
				    		this.$eltips(res.msg,'error')
				    	}
				    })
				}).catch(() => {});
			},
			refuse(id){
				this.$prompt('请输入驳回理由', '驳回申请', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputType:'textarea',
					inputValidator(value){
						if(!value){ return '驳回理由不能为空' }
						if(value.replace(/\s/g,'').length<1){ return '驳回理由不能为空' }
					},
					inputErrorMessage: '驳回理由不能为空'
				}).then(({ value }) => {
					this.$axios.post('/api/client/ES/policysApprove',{
						id:id,
						type:2,
						remarks:value,
					}).then(res=>{
						if(res.code==200){
							this.$eltips(res.msg,'success')
							this.getList()
						}else{
							this.$eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			getList(){
				this.loading = true
				let data={
					page: this.page,
					limit: this.limit,
					status:this.selectStatus,
					policy_id:this.id
				}
				this.$axios.get('/api/client/ES/getPolicysApply', {params: data}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.total = res.data.total
						this.list = res.data.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			changePage(e) {
				console.log(e, '---e')
				this.page = e
				this.getList()
			},
			add(id){
				this.$router.push({
					name: 'addPolicy',
					query: {
						id: id
					}
				});
			},
			changeStatus(status){
				this.selectStatus=status
				this.page=1
				this.getList()
			},
			// 通过和驳回
			controls(id,type){
				this.controlsId=id
				if(type==2){
					this.dialogVisible=true
				}else{
					this.controlsRequest(1)
				}
			},
			controlsRequest(type){
				this.loading = true
				this.$axios.post('/api/client/ES/policysApprove', {
					id: this.controlsId,
					type:type,
					remarks:this.msg
				}).then(res => {
					if (res.code == 200) {
						this.dialogVisible=false
						this.loading = false
						this.$eltips(res.msg)
						this.getList()
					} else {
						this.loading = false
						this.$eltips(res.msg, 'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.declareRoad{
		position: relative;
		padding: 24px 0;
		display: flex;
		justify-content: center;
		.red {
			font-size: 14px;
			margin-top: 20px;
			color: red;
		}
		.declareRoadCon{
			width: 1200px;
			margin: 0 auto;
			position: relative;
			z-index: 2;
			.head{
				background-color: #FFF;
				margin-bottom: 16px;
				padding: 28px 38px 20px;
				border-radius: 16px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.title {
					color: #151515;
					font-size: 28px;
					font-weight: bold;
				}
				
				.label {
					display: flex;
					align-items: center;
					margin-top: 28px;
					.li {
						color: #151515;
						font-size: 18px;
						font-weight: bold;
						margin-right: 74px;
						cursor: pointer;
						&:hover {
							color: #51A190;
						}
					}
				
					.active {
						color: #51A190;
						position: relative;
				
						&::after {
							content: '';
							display: block;
							width: 20px;
							height: 4px;
							background-color: #9B6CFF;
							border-radius: 16px;
							bottom: -12px;
							left: 50%;
							position: absolute;
							transform: translate(-50%, 0);
						}
					}
				}
			}
			
			.page {
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 48px 0 0;
			}
		
		    .ul{
				min-height: 400px;
				.nodata{
					height: 400px;
					background: #FFFFFF;
					border-radius: 16px;
				}
				.li{
					padding: 18px 38px;
					background-color: #FFF;
					border-radius: 16px;
					margin-bottom: 20px;
					&:last-child{
						margin-bottom: 0;
					}
					.title{
						color: #151515;
						font-size: 22px;
						margin-bottom: 22px;
					}
					.bottom{
						display: flex;
						align-items: center;
						justify-content: space-between;
						.logoCon{
							display: flex;
							align-items: center;
							.logo{
								width: 60px;
								height: 60px;
								margin-right: 16px;
								border-radius: 50%;
							}
							.right{
								.name{
									color: #151515;
									font-size: 15px;
									margin-bottom: 17px;
								}
								.time{
									font-size: 15px;
								}
							}
						}
						.num{
							color: #5E5E5E;
							font-size: 14px;
							display: flex;
							align-items: center;
							.numLi{
								padding: 0 16px;
								&:last-child{
									border-left: 1px solid #D3D6DB;
								}
							}
						}
						.status{
							display: flex;
							align-items: center;
							font-size: 16px;
							.dot{
								width: 12px;
								height: 12px;
								border-radius: 50%;
								background-color: #51A190;
								margin-right: 6px;
							}
							color: #151515;
						}
						.controls{
							display: flex;
							align-items: center;
							margin-left: 30px;
							.button{
								margin-right: 18px;
								font-size: 16px;
								cursor: pointer;
								&:last-child{
									margin-right: 0;
								}
							}
						}
					}
				}
			}
		}
	}
</style>